import * as React from 'react';
import { SvgIcon } from '../SvgIcon';

interface IProps {
	className?: string;
	fill?: string;
	height?: number;
	width?: number;
}

export const LocationIcon: React.FC<IProps> = props => {
	const { className, fill, height = 21, width = 14 } = props;
	return (
		<SvgIcon
			className={className ?? ''}
			width={width}
			height={height}
			viewBox='0 0 14 21'
			fill={fill}
			xmlns='http://www.w3.org/2000/svg'
		>
			<g id='Design' stroke='none' strokeWidth='1' fill='none' fillRule='evenodd'>
				<g id='Contact-Profile-Copy' transform='translate(-892, -830)' fill={fill}>
					<g id='Group-8' transform='translate(888, 285.3695)'>
						<g id='Fill-1592-+-Fill-1593' transform='translate(4, 545.5004)'>
							<path
								d='M7,6 C6.449,6 6,6.449 6,7 C6,7.552 6.449,8 7,8 C7.551,8 8,7.552 8,7 C8,6.449 7.551,6 7,6 M7,10 C5.346,10 4,8.654 4,7 C4,5.346 5.346,4 7,4 C8.654,4 10,5.346 10,7 C10,8.654 8.654,10 7,10'
								id='Fill-1592'
							/>
							<path
								d='M7,2 C4.243,2 2,4.243 2,7 C2,9.591 5.107,14.583 7,17.291 C8.892,14.582 12,9.589 12,7 C12,4.243 9.757,2 7,2 M7,20.667 C4.641,17.52 -1.11022302e-16,10.936 -1.11022302e-16,7 C-1.11022302e-16,3.14 3.14,0 7,0 C10.86,0 14,3.14 14,7 C14,10.936 9.359,17.521 7,20.667'
								id='Fill-1593'
							/>
						</g>
					</g>
				</g>
			</g>
		</SvgIcon>
	);
};
